//Menu burger function 
let trigger_burger = 0;
let b_trigger = 0;


//job form id variables
var formId = 2;


function showMenu() {
	if (trigger_burger == 0) {
		showMainMenu();
	} else {
		closeMainMenu();
	}
}
function showMainMenu() {
	document.getElementById('burger').classList.add('close');
	document.getElementById('burger').getElementsByClassName('text')[0].innerHTML = 'Close <em>Menu</em>';
	document.getElementById('primary-nav').classList.add('open');
	trigger_burger = 1;
}
function closeMainMenu() {
	document.getElementById('burger').classList.remove('close');
	document.getElementById('burger').getElementsByClassName('text')[0].innerHTML = 'Open <em>Menu</em>';
	document.getElementById('primary-nav').classList.remove('open');
	trigger_burger = 0;
}

function showABooking() {
	document.getElementById('booking-form').classList.add('open');
	document.getElementById('tobook').innerHTML = 'Close <em>Now</em>';
	b_trigger = 1;
}
function hideABooking() {
	document.getElementById('booking-form').classList.remove('open');
	document.getElementById('tobook').innerHTML = 'Reserve <em>Now</em>';
	b_trigger = 0;
}


$( "#booking-form" ).on( "submit", () => {

	let rooms = document.querySelector( "#rooms" )
	console.log( rooms.value );
	if( rooms.value >= 5 ){
		document.location = "/events/groups#experience-boise";
	}

} )


//accommodations show video
/*if (document.getElementsByClassName('image-video').length > 0) {
	const roomvideos = document.getElementsByClassName('image-video');
	let theight = 250 + document.getElementsByClassName('intro')[0].offsetHeight;
	let accommodationspos = [];
	for (let m = 0; m < roomvideos.length; m++) {
		let ttop = theight;
		theight = ttop + roomvideos[m].offsetHeight;
		accommodationspos.push(ttop);
	}
	window.addEventListener('scroll', function () {
		let wtop = window.pageYOffset;
		for (let m = 0; m < roomvideos.length; m++) {
			if (wtop >= accommodationspos[m] && wtop < (accommodationspos[m] + 500)) {
				for (let n = 0; n < roomvideos.length; n++) {

					if (n == m) {
						roomvideos[m].classList.add('active');
						let sibilings = getSiblings(roomvideos[m]);
						for (let j = 0; j < sibilings.length; j++) {
							sibilings[j].classList.add('active');
						}
					} else {
						roomvideos[n].classList.remove('active');
						stopVideo(roomvideos[n]);
						let sibilings = getSiblings(roomvideos[n]);
						for (let j = 0; j < sibilings.length; j++) {
							sibilings[j].classList.remove('active');
						}
					}
				}

			}
		}
	});

}*/

const videoAccommodation = () => {
	let heightWindow = window.innerHeight;
	let minRangeHeightWindow = heightWindow * 20 / 100;
	let maxRangeHeightWindow = heightWindow * 50 / 100;
	let eachRoom = document.querySelectorAll('.accommodations .room.item');

	eachRoom.forEach( room => {
		window.addEventListener('scroll', () => {
			let positionOfRoom = room.getBoundingClientRect().top;
			if( positionOfRoom > minRangeHeightWindow && positionOfRoom < maxRangeHeightWindow ){
				room.querySelector('.image-video').classList.add('active');
				room.querySelector('.image').classList.add('active');
				playVideo(room)
			}else{
				room.querySelector('.image-video').classList.remove('active');
				room.querySelector('.image').classList.remove('active');
				stopVideo(room)
			}
		});
	});
}

let getSiblings = function (elem) {
	let siblings = [];
	let sibling = elem.parentNode.firstChild;
	for (; sibling; sibling = sibling.nextSibling) {
		if (sibling.nodeType !== 1 || sibling === elem) continue;
		siblings.push(sibling);
	}
	return siblings;
};
let stopVideo = function (element) {
	let iframe = element.querySelector('iframe');
	if (iframe) {
		let iframeSrc = iframe.src;
		iframe.src = iframeSrc;
	}

};
let playVideo = function (element) {
	let iframe = element.querySelector('iframe');
	let video = element.querySelector('video');
	if (iframe) {
		let current = iframe.src;
		let iframeSrc = iframe.src;
		if (iframeSrc.indexOf('autoplay') === -1) {
			iframe.src = iframeSrc + '&autoplay=1';
		}
	}
	if (video) {
		video.play();
	}

};

//Show Booking 

function showBooking() {
	console.log({b_trigger});
	
	if (b_trigger == 0) {
		showABooking();
	} else {
		hideABooking();
	}
}

if( document.querySelector('.tobook-js') ) {
	document.querySelector('.tobook-js').addEventListener('click', (e) => {
		showBooking();

	})
}


//Booking select
function SelectChange(current, id, val) {
	if (id == 'rooms') {
		if (val == 1) {
			var text = ' Room';
		} else {
			var text = ' Rooms';
		}
	} else {
		if (val == 1) {
			var text = ' Guest';
		} else {
			var text = ' Guests';
		}
	}

	document.getElementById(id).previousElementSibling.innerHTML = val + text;
}


window.onscroll = function () {

	let header = document.getElementById('header');
	if (header) {
		if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
			header.classList.add('down');
		} else {
			header.classList.remove('down');
		}
	}



}


//home h2 to have class h1
if (document.getElementsByTagName('body')[0].id == 'home') {
	for (var i = 0; i < document.getElementsByTagName('h2').length; i++) {
		var currentelement = document.getElementsByTagName('h2')[i];
		if (currentelement.parentNode.classList.contains('text')) {
			currentelement.classList.add('h1');
		}
	}
}


//homemap
function showPin(datapin) {

	var current = datapin.getAttribute('data');

	for (var j = 0; j < document.getElementsByClassName('homepin').length; j++) {
		document.getElementsByClassName('homepin')[j].classList.remove('active');
	}
	for (var j = 0; j < document.getElementsByClassName('homepin').length; j++) {
		if (document.getElementsByClassName('homepin')[j].getAttribute('data') == current) {
			document.getElementsByClassName('homepin')[j].classList.add('active');
		}
	}
}



function resizeWindow() {
	if ($(window).width() < 1000) {
		$('.list .item, .overview-list .item').each(function () {
			$(this).find('.image').insertBefore($(this).find('.text'));
		});
	} else {
		$('.list.align-right .item:nth-child(odd)').each(function () {
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
		$('.list.align-left .item:nth-child(even)').each(function () {
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
		$('.overview-list.left-aligned .item:nth-child(odd)').each(function () {
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
		$('.overview-list.right-aligned .item:nth-child(even)').each(function () {
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
	}
}
function scrollDown() {
	if ($('body.boise-map').length > 0 || $('body.photos').length > 0) {
		if (!$('#header').hasClass('down')) {
			$('#header').addClass('down')
		}
	}
	//no header pages
	if ($('#bottom-content').hasClass('noheader')) {
		if (!$('#header').hasClass('down')) {
			$('#header').addClass('down');
		}

	}
}

$(document).ready(function () {


	function _get_form_token(){
		$.get(
			site_url + '/ajax/functions.php?operation=_get_form_token',
			function(resp) {
				$("input[name=_token][type=hidden]").each( function(){
					this.value = resp
				})		
			}		
		);
	}
	$(function () {
		_get_form_token();
	})

	

	//btn 
	$(".btn").html(function () {
		var text = $(this).text().trim().split(" ");
		var first = text.shift();
		return (text.length > 0 ? "<em>" + first + "</em> " : first) + text.join(" ");
	});
	$(".btn").wrapInner('<span></span>');

	//seemore
	$(".seemore").html(function () {
		var text = $(this).text().trim().split(" ");
		var first = text.shift();
		return (text.length > 0 ? "<em>" + first + "</em> " : first) + text.join(" ");
	});

	//accommodations name
	$(".name span").html(function () {
		var text = $(this).text().trim().split(" ");
		var first = text.shift();
		return (text.length > 0 ? "<em>" + first + "</em> " : first) + text.join(" ");
	});
	$(".floorplan span").html(function () {
		var text = $(this).text().trim().split(" | ");
		var first = text.shift();
		return (text.length > 0 ? "<b>" + first + "</b> | " : first) + text.join(" | ");
	});

	//fielset legends
	$("fieldset legend").html(function () {
		var text = $(this).text().trim().split(" ");
		var first = text.shift();
		return (text.length > 0 ? "<em>" + first + "</em> " : first) + text.join(" ");
	});

	//no btn for forms buttons
	$('#frmContact .btn, #formRFP .btn').removeClass('btn');


	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});


	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	});

	// Main Nav Dropdown
	/*
			$("#primary-nav li").hover(function(){
	
					$(this).addClass("hover");
					$('ul.submenu',this).fadeIn(200);
	
			}, function(){
	
					$(this).removeClass("hover");
					$('ul.submenu',this).fadeOut(200);
	
			});
	*/

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2
		},
			800, 'easeOutExpo');
	});

	//Remove empty <p> tags created by tinymce
	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
			$this.remove();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
	//GA parametters :  ga('send', 'event', [eventCategory], [eventAction], [eventLabel]);
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	//this class should be add to the header widget submit button
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	$("#event_date").datepicker({
		//showOn: "both",
		maxDate: '+365D',
		//dateFormat: "yy/mm/dd 23:59:59",
	//	timeFormat:  "hh:mm:ss",
	//	altFormat: "M dd, yy",
	});


	
	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		//yearRange: new Date().getFullYear()+":"+(new Date().getFullYear() + 1),
		maxDate: '+365D',
		altField: "#arrival_date",
		altFormat: "M dd, yy",
		onSelect: function (selectedDate) {
			var getDate = $(this).datepicker('getDate');
			var newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 1);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
			SetDate();
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,

		
		numberOfMonths: 2,
		altField: "#departure_date",
		altFormat: "M dd, yy",
		maxDate: '+365D',
		onSelect: function (selectedDate) {
			//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			SetDate();
		}
	});




	// Map: Return to previous page button. Change body id to match map template's name.
	$('body.boise-map #content').prepend('<a class="return-from-map" href="javascript:history.back()"><em>« Back </em>to previous page</a>');


	//if job app form
	if(document.getElementById('form_id-826')){
		let gdprWrap = document.getElementById('form_id-826').getElementsByClassName('gdpr-wrap')[0]
		let newDateWrap = document.createElement('div')
		newDateWrap.classList.add('form-module__field')
		newDateWrap.classList.add('col-6')
		newDateWrap.classList.add('bottom-aligned')

		//current day
		let today = new Date();
		const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]
		let dd = String(today.getDate()).padStart(2, '0');
		newDateWrap.innerHTML = 'Signed today: <span>' + monthNames[today.getMonth()] + ' ' + dd + '/ ' + today.getFullYear() + '</span>'

		document.getElementById('form_id-826').insertBefore(newDateWrap,gdprWrap)

		//Add more employers button
		addEmployersbutton();
	}

	if ($('body.sitemap').length > 0) {
		$('#top-content').remove();
		$('#bottom-content').addClass('noheader');
	}

	//fancybox iframe



	$(".fancyboxiframe").fancybox({
		maxWidth: 853,
		maxHeight: 480,
		fitToView: false,
		width: '90%',
		height: '90%',
		autoSize: false,
		closeClick: false,
		openEffect: 'none',
		closeEffect: 'none',
		padding: 0,
		iframe: {
			scrolling: 'auto',
			preload: true
		}
	});

	if ($('#amenityMenu').length > 0) {
		$('#amenityMenu dl dt').each(function () {
			if ($(this).attr('data-rel') == 'wine-tasting-room') {
				console.log('wine');
				$(this).find('a').html('Tasting Rooms');
			}
		});
	}

	$('form .btnSubmit').click(function () {
		setTimeout(function () {
			$('p#thankyou').fadeOut(500);
			if ($('.popup-container').length > 0) {
				$('.popup-container').removeClass('active')
			}
		}, 6000);

	});

	//popup hard coded
	/*Only load Intro at First*/
	var COOKIE_NAME = 'br_cookie';
	var go = $.cookie(COOKIE_NAME);
	if (go == null) {

		$.cookie(COOKIE_NAME, 'test', {
			path: '/',
			expires: 30
		});
		setTimeout(function () {
			$('.popup-container').addClass('active');
		}, 2500);

		console.log("cookie");

	} else {
		console.log("no-cookie");
	}
	$('.popup-container__close').click(function () {
		$('.popup-container').removeClass('active');
	});


	//landing page
	if ($('#landing-page')) {
		$('#landing-page #header').remove();
	}

	if( document.querySelectorAll('.accommodations .image-video') ){
		videoAccommodation();
	}

});

$(window).load(function () {
	scrollDown();
	resizeWindow();

	$('.sym-slides').on('init', function (event, slick) {
		equalize();
	});

	//Slick Slider
	$('.sym-slides').slick();

});

function SetDate() {
	$('.fakeinput').addClass('withdate');
	$('.checkin .fakeinput').text($('#arrival_date').attr('value'));
	$('.checkout .fakeinput').text($('#departure_date').attr('value'));
}
function addEmployersbutton() {
	let jobForm = document.getElementById('form_id-826');
	let referenceElement = document.getElementById('id_65_826');

	let newButton = document.createElement('a');
	newButton.classList.add('js-add-new-employer');
	newButton.innerHTML = 'Add Employer';
	jobForm.insertBefore(newButton,referenceElement)

	newButton.addEventListener('click', function(){
		let newFieldset = document.createElement('div');
		newFieldset.setAttribute('id','id_826_'+formId);
		newFieldset.classList.add('job-form-fieldset');

		newFieldset.innerHTML = '<h3>Employer '+formId+'</h3><div class="form-module__field input col-4"><label class="hidden" for="id826'+formId+'">Employer Name</label><input name="employer_name_'+formId+'" type="text" id="id826'+formId+'" placeholder="Employer Name"></div><div class="form-module__field input col-4"><label class="hidden" for="id8261'+formId+'">Supervisor</label><input name="supervisor_'+formId+'" type="text" id="id8261'+formId+'" placeholder="Supervisor"></div><div class="form-module__field input col-4"><label class="hidden" for="id8262'+formId+'">Address</label><input name="employer_address_'+formId+'" type="text" id="id8262'+formId+'" placeholder="Employer Address"></div><div class="form-module__field input col-4"><label class="hidden" for="id8263'+formId+'">Phone</label><input name="employer_phone_'+formId+'" type="text" id="id8263'+formId+'" placeholder="Employer Phone"></div><div class="form-module__field input col-4"><label class="hidden" for="id8264'+formId+'">Position</label><input name="employer_position_'+formId+'" type="text" id="id8264'+formId+'" placeholder="Position Held"></div><div class="form-module__field input col-12"><label class="hidden" for="id8265'+formId+'">Reason</label><input name="reason_leave_'+formId+'" type="text" id="id8265'+formId+'" placeholder="Reason for leaving"></div><div class="form-module__field date col-6"><label class="hidden" for="id8266'+formId+'">Start Date</label><input name="start_date_'+formId+'" type="text" class="newdatepicker" id="id8266'+formId+'" placeholder="Start Date" autocomplete="off"></div><div class="form-module__field date col-6"><label class="hidden" for="id8267'+formId+'">End Date</label><input name="end_date_'+formId+'" type="text" class="newdatepicker" id="id8267'+formId+'" placeholder="End Date" autocomplete="off"></div><div class="form-module__field input col-12"><label class="hidden" for="id8268'+formId+'">Duties</label><input name="duties_'+formId+'" type="text"  id="id8268'+formId+'" placeholder="Duties"><div class="form-module__field--description">List the duties and responsibilities for Employer</div></div>';
		formId++;
		jobForm.insertBefore(newFieldset,newButton);

		setTimeout(function(){
			$('.newdatepicker').datepicker();
		},500);
	})
}
